export default [
  {
    path: '/widget/orders/:token/returnUrl',
    name: 'ReturnUrl',
    component: () => import('@/views/widget/ReturnUrl.vue'),
    meta: {
      layout: 'full',
      resource: 'widget',
      notRedirectIfNotLoggedIn: true,
      notRedirectIfLoggedIn: true,
      action: 'read',
    },
  },
  {
    path: '/widget/orders/:token/failUrl',
    name: 'FailUrl',
    component: () => import('@/views/widget/FailUrl.vue'),
    meta: {
      layout: 'full',
      resource: 'widget',
      notRedirectIfNotLoggedIn: true,
      notRedirectIfLoggedIn: true,
      action: 'read',
    },
  },
]
